/**
 * Local travel photos — royalty-free from Pexels (https://www.pexels.com/license/)
 * Free for commercial and personal use; no attribution required.
 * Files live in /public/images/
 */
const img = (file) => `${process.env.PUBLIC_URL}/images/${file}`;

export const IMAGES = {
  hero: 'https://images.pexels.com/photos/912050/pexels-photo-912050.jpeg?auto=compress&cs=tinysrgb&w=2000',
  mumbai: img('mumbai.jpg'),
  london: img('london.jpg'),
  newYork: img('new-york.jpg'),
  bangkok: img('bangkok.jpg'),
  miamiBeach: img('miami-beach.jpg'),
  mountainLake: img('mountain-lake.jpg'),
  chicago: img('chicago.jpg'),
  tropicalBeach: img('tropical-beach.jpg'),
  paris: img('paris.jpg'),
  londonBridge: img('london-bridge.jpg'),
  tokyo: img('tokyo.jpg'),
  dubai: img('dubai.jpg'),
  amsterdam: img('amsterdam.jpg'),
  toronto: img('toronto.jpg'),
  losAngeles: img('los-angeles.jpg'),
  travelPlanning: img('travel-planning.jpg'),
  luggageCouple: img('luggage-couple.jpg'),
  supportAgent: img('support-agent.jpg'),
  airplane: img('airplane.jpg'),
  hotelRoom: img('hotel-room.jpg'),
  rentalCar: img('rental-car.jpg'),
  cruiseShip: img('cruise-ship.jpg'),
  vacationPackage: img('vacation-package.jpg'),
};

export const IMAGE_ATTRIBUTION = 'Destination photos from Pexels (free license).';
